module.exports = __webpack_public_path__ + "d5e4283aafd8e30076bd95d9e75b74bc.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icn-socially-responsible.svg
// module id = 1422
// module chunks = 0